import React, { useEffect, useState } from "react";
import { api, formatApiError } from "../../lib/api";
import { toast } from "sonner";

export default function GovComplaints() {
  const [rows, setRows] = useState([]);
  useEffect(() => {
    api.get("/gov/complaints").then(r => setRows(r.data)).catch(e => toast.error(formatApiError(e)));
  }, []);

  return (
    <div className="space-y-4" data-testid="gov-complaints">
      <div>
        <h1 className="font-heading text-3xl">Citizen Complaints</h1>
        <p className="text-sm text-[#5C5A55] mt-1">Read-only · {rows.length} records</p>
      </div>

      <div className="bg-white border border-[#E5E2D9] rounded-md">
        <table className="w-full text-sm">
          <thead>
            <tr className="bg-[#F7F6F2] text-left text-[11px] uppercase tracking-[0.2em] text-[#5C5A55]">
              <th className="px-6 py-3">Date</th>
              <th className="px-6 py-3">Subject</th>
              <th className="px-6 py-3">Status</th>
              <th className="px-6 py-3">Priority</th>
            </tr>
          </thead>
          <tbody>
            {rows.length === 0 && <tr><td colSpan={4} className="px-6 py-12 text-center text-[#8A8780]">No complaints.</td></tr>}
            {rows.map((t, i) => (
              <tr key={t.id} className={i % 2 === 0 ? "bg-white" : "bg-[#FAFAF7]"}>
                <td className="px-6 py-3 text-xs font-mono">{t.created_at ? new Date(t.created_at).toLocaleDateString() : "—"}</td>
                <td className="px-6 py-3">{t.subject || t.title || "—"}</td>
                <td className="px-6 py-3 capitalize">{t.status || "—"}</td>
                <td className="px-6 py-3 capitalize text-[#5C5A55]">{t.priority || "—"}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
